import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04236dd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_text" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "观风云变幻 探气象万千"),
  /*#__PURE__*/_createElementVNode("p", null, "为您提供更高时、空分辨率的气象数据服务产品"),
  /*#__PURE__*/_createElementVNode("div", { class: "_btn" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "_try" }, " 了解更多 ")
  ])
], -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_text" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "触达用户 赋能行业发展"),
  /*#__PURE__*/_createElementVNode("p", null, "以行业为中心，价值赋能，构建“+气象”服务生态"),
  /*#__PURE__*/_createElementVNode("div", { class: "_btn" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "_try" }, " 了解更多 ")
  ])
], -1))
const _hoisted_7 = { class: "_text" }
const _hoisted_8 = { class: "en" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_btn" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "_try" }, " 了解更多 ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-list" }, null, -1))

import { reactive } from "vue";

import img_1 from "@/static/Home/banner/banner1.mp4";
import img_2 from "@/static/Home/banner/banner2.mp4";
import img_3 from "@/static/Home/banner/banner4.jpg";
import img_4 from "@/static/Home/banner/banner3.jpg";

import productService from "@/views/Home/page/productService.vue";
import resolveProject from "@/views/Home/page/resolveProject.vue";
import cooperativePartner from "@/views/Home/page/cooperativePartner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const bannerList = reactive([
  // {
  //   img: img_2,
  //   title: "翼搜气象",
  //   msg: "为您提供专业的气象数据服务",
  // },
  {
    img: img_3,
    title: "风雨不动安如山",
    msg: "权威授权，高效支撑，致力构建以自然资源为核心的气象服务基础设施",
    // en: "Provide you with professional meteorological services",
  },
  {
    img: img_4,
    title: "灾害无情 让我为你守护",
    msg: "我们的使命：用“智慧气象”造福大众",
    en: "Guardian Of Your Life",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_carousel, {
          interval: 8000,
          arrow: "always"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("video", {
                    style: {"width":"-webkit-fill-available"},
                    src: _unref(img_1),
                    autoplay: "",
                    loop: "",
                    muted: ""
                  }, null, 8, _hoisted_3),
                  _hoisted_4
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("video", {
                    style: {"width":"-webkit-fill-available"},
                    src: _unref(img_2),
                    autoplay: "",
                    loop: "",
                    muted: ""
                  }, null, 8, _hoisted_5),
                  _hoisted_6
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerList, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_image, {
                      src: item.img,
                      fit: "cover"
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(item.en), 1),
                      _createElementVNode("p", null, _toDisplayString(item.msg), 1),
                      _hoisted_9
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _hoisted_10
    ]),
    _createElementVNode("div", null, [
      _createVNode(productService),
      _createVNode(resolveProject),
      _createVNode(cooperativePartner)
    ])
  ], 64))
}
}

})